/* eslint-disable import/prefer-default-export */
import { CreatePaymentInput } from 'models/CreatePaymentInput';
import axios from './axios';

export const postStripePayment = (input: CreatePaymentInput) => axios.post('/payment', input).then((res) => res.data);
